/**
 * Thông tin đơn vị dùng cho letterhead phiếu lương / PDF (B2 — v0.18).
 *
 * ► CÁCH THAY TÊN/LOGO THẬT:
 *   - Sửa các giá trị bên dưới thành tên chính thức của đơn vị.
 *   - Logo: đặt file vào `public/logo.png` rồi gán `logoUrl: '/logo.png'`,
 *     hoặc nhúng data URI. Để trống → hiển thị ô chữ viết tắt.
 */
export const ORG = {
  /** Đơn vị chủ quản (dòng nhỏ phía trên), có thể để rỗng. */
  parentName: '',
  /** Tên đầy đủ của đơn vị — in đậm trên phiếu lương. */
  name: 'Trung Tâm Vận Tải Đối Ngoại V75',
  /** Tên viết tắt — hiển thị trong ô logo khi chưa có ảnh. */
  shortName: 'V75',
  /** Địa chỉ / dòng phụ dưới tên đơn vị, có thể để rỗng. */
  address: '',
  /**
   * Đường dẫn logo. Đặt file logo vào `public/logo.png` → tự hiển thị.
   * Nếu file chưa tồn tại, letterhead tự fallback về ô chữ viết tắt.
   */
  logoUrl: '/logo.png',
} as const

/**
 * Đầu trang + người ký cho văn bản in (v0.47) — lấy theo mẫu bảng chấm công
 * C01a của đơn vị (Lương2026). Chưa gộp vào ORG.parentName để không đổi
 * letterhead phiếu lương khi user chưa xác nhận.
 */
export const PRINT_HEADER = {
  parentName: 'Bộ Ngoại giao',
  /** Giám đốc ký bảng chấm công / quyết định */
  directorName: 'Hoàng Dũng',
  place: 'Hà Nội',
} as const

/**
 * Thông tin tác giả phần mềm — quyền nhân thân theo Luật Sở hữu trí tuệ,
 * KHÔNG được gỡ bỏ khỏi sản phẩm dưới mọi hình thức.
 */
export const AUTHOR = {
  /** Họ tên tác giả — chủ sở hữu quyền tác giả phần mềm. */
  name: 'Đàm Mạnh Cường',
  /** Dòng 1 credit (nhãn tiếng Anh) — hiển thị kèm © + năm. */
  creditLine1: 'Software Author: Đàm Mạnh Cường',
  /** Dòng 2 credit. */
  creditLine2: 'Phần mềm lưu hành nội bộ V75',
  /** Bản gộp 1 dòng — dùng cho nơi không xuống dòng được (Props Excel...). */
  credit: 'Software Author: Đàm Mạnh Cường — Phần mềm lưu hành nội bộ V75',
  /** Logo cá nhân 3D chữ MC độc quyền của tác giả. */
  logoUrl: '/author-logo.svg',
} as const
